<template>
  <b-modal
    id="ScriptSettings"
    size="lg"
    content-class="menu-bg-blue-transparent-modal sa-modal"
    title="Automation Script Setting"
    hide-footer
  >
    <div>
      <b-row class="col-sm-12 p-4">
        <b-col class="col-sm-6">
          <b-form-select v-model="customer" @change="hideMsg()">
            <template #first>
              <b-form-select-option :value="null" disabled>
                Select Customer *
              </b-form-select-option>
            </template>
            <b-form-select-option value="GM">GM</b-form-select-option>
            <b-form-select-option value="Nissan">Nissan</b-form-select-option>
            <b-form-select-option value="Subaru">Subaru</b-form-select-option>
            <b-form-select-option value="Rivian">Rivian</b-form-select-option>
          </b-form-select>
        </b-col>
        <b-col class="col-sm-6">
          <b-form-select
            v-model="processingType"
            v-if="customer == 'Nissan'"
            @change="hideMsg()"
          >
            <template #first>
              <b-form-select-option :value="null" disabled>
                Select Processing Type *
              </b-form-select-option>
            </template>
            <b-form-select-option value="ANSI">ANSI/DRT</b-form-select-option>
            <b-form-select-option value="FA">FA Patch</b-form-select-option>
          </b-form-select>
          <b-form-select
            v-model="processingType"
            v-else-if="customer == 'Rivian'"
            @change="hideMsg()"
          >
            <template #first>
              <b-form-select-option :value="null" disabled>
                Select Processing Type *
              </b-form-select-option>
            </template>
            <b-form-select-option value="ANSI">ANSI</b-form-select-option>
          </b-form-select>
          <b-form-select
            v-model="processingType"
            v-else
            @change="hideMsg()"
          >
            <template #first>
              <b-form-select-option :value="null" disabled>
                Select Processing Type *
              </b-form-select-option>
            </template>
            <b-form-select-option value="ANSI">ANSI</b-form-select-option>
            <b-form-select-option value="DRT">DRT</b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>
      <b-row class="col-sm-12 p-4">
        <b-col class="col-sm-6">
          <b-form-select v-model="dblink">
            <template #first>
              <b-form-select-option :value="null" disabled>
                Select Database Server *
              </b-form-select-option>
            </template>
            <b-form-select-option
              v-for="db in dblist"
              :key="db.id"
              :value="db.connection_link"
            >
              {{ db.name }}
            </b-form-select-option>
          </b-form-select>
        </b-col>
        <b-col class="col-sm-6"  v-if="customer == 'GM' && processingType == 'ANSI'">
          <b-form-select v-model="processing_type">
            <template #first>
              <b-form-select-option :value="null" disabled>
                Select ANSI Processing Type *
              </b-form-select-option>
            </template>
            <b-form-select-option value="Regular_1250">Regular_1250</b-form-select-option>
            <b-form-select-option value="Split_Sample">Split_Sample</b-form-select-option>
            <b-form-select-option value="Secondaries">Secondaries</b-form-select-option>
          </b-form-select>
        </b-col>
        <b-col class="col-sm-6"  v-if="customer == 'Subaru' && processingType == 'ANSI'">
          <b-form-select v-model="processing_type">
            <template #first>
              <b-form-select-option :value="null" disabled>
                Select ANSI Processing Type *
              </b-form-select-option>
            </template>
            <b-form-select-option value="Regular_1250">Regular_1250</b-form-select-option>
            <b-form-select-option value="Biased">Biased</b-form-select-option>
          </b-form-select>
        </b-col>
        <b-col class="col-sm-6"  v-if="customer == 'Rivian' && processingType == 'ANSI'">
          <b-form-select v-model="processing_type">
            <template #first>
              <b-form-select-option :value="null" disabled>
                Select ANSI Processing Type *
              </b-form-select-option>
            </template>
            <!-- <b-form-select-option value="Regular_1250">Regular_1250</b-form-select-option> -->
            <b-form-select-option value="Biased">Biased</b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>
      <b-tabs content-class="mt-2" pills card justified>
        <b-tab title="Execute Scripts" active>
          <!-- DRT Card -->
          <b-card
            v-if="customer == 'GM' && processingType == 'DRT'"
            header-html="<b>DRT Processing</b>"
            class="hide-hor-scroll p-1 menu-bg-blue-transparent"
            no-body
          >
            <b-form-group class="px-3 py-2">
              <label>Database Name *</label>
              <b-form-input
                name="databaseName"
                v-model="databaseName"
                autocomplete="off"
              />
              <br />
              <span> Note: Database name is case sensitive. </span>
            </b-form-group>

            <b-container class="p-2" v-if="submitSuccess.length">
              <b-col class="text-center">
                <span>
                  <ul class="list-group">
                    <div
                      class="alert alert-success"
                      v-for="msg in submitSuccess"
                      :key="msg"
                    >
                      <li class="list-group-item">{{ msg }}</li>
                    </div>
                  </ul>
                </span>
              </b-col>
            </b-container>
            <b-row class="p-2" v-if="submitErrors.length > 0">
              <b-col class="text-center">
                <span>
                  <div v-for="(msg, index) in submitErrors">
                    <div class="alert">
                      <span class="alert alert-danger">{{ msg }}</span>
                      <fa :icon="['fas', 'window-close']" @click="removeMsg(index)" class="cursor-pointer"/>
                    </div>
                  </div>
                </span>
              </b-col>
            </b-row>
            <b-row class="p-3">
              <b-col class="text-center">
                <b-button
                  variant="primary"
                  class="btn-md m-2"
                  type="submit"
                  @click="runGMDrtScript()"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <!-- ANSI Card -->
          <b-card
            v-if="customer == 'GM' && processingType == 'ANSI'"
            header-html="<b>ANSI Processing</b>"
            class="hide-hor-scroll menu-bg-blue-transparent"
            no-body
          >
            <b-form-group class="px-3 py-2">
              <label>Database Name *</label>
              <b-form-input
                name="databaseName"
                v-model="databaseName"
                autocomplete="off"
              />
              <br />
              <span> Note: Database name is case sensitive. </span>
            </b-form-group>
            <b-row class="px-3 py-2">
              <b-col>
                <label>Date *</label>
                <b-form-input name="date" v-model="date" autocomplete="off" />
              </b-col>
              <b-col>
                <label>Part Number *</label>
                <b-form-input
                  name="partNumber"
                  v-model="partNumber"
                  autocomplete="off"
                />
              </b-col>
            </b-row>
            <b-row class="px-3 py-2">
              <b-col>
                <label>Type *</label>
                <b-form-select v-model="type">
                  <option>CSAV3</option>
                  <option>CSAV3PLUS</option>
                </b-form-select>
              </b-col>
              <b-col>
                <label>Segment Count *</label>
                <b-form-input name="count" v-model="count" autocomplete="off" />
              </b-col>
            </b-row>
            <b-container class="p-2" v-if="submitSuccess.length">
              <b-col class="text-center">
                <span>
                  <ul class="list-group">
                    <div
                      class="alert alert-success"
                      v-for="msg in submitSuccess"
                      :key="msg"
                    >
                      <li class="list-group-item">{{ msg }}</li>
                    </div>
                  </ul>
                </span>
              </b-col>
            </b-container>
            <b-row class="p-2" v-if="submitErrors.length > 0">
              <b-col class="text-center">
                <span>
                  <div v-for="(msg, index) in submitErrors">
                    <div class="alert">
                      <span class="alert alert-danger">{{ msg }}</span>
                      <fa :icon="['fas', 'window-close']" @click="removeMsg(index)" class="cursor-pointer"/>
                    </div>
                  </div>
                </span>
              </b-col>
            </b-row>
            <b-row class="p-3">
              <b-col class="text-center">
                <b-button
                  variant="primary"
                  class="btn-md m-2"
                  type="submit"
                  @click="runGMAnsiScript()"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <!-- DRT Card -->
          <b-card
            v-if="customer == 'Subaru' && processingType == 'DRT'"
            header-html="<b>Subaru DRT Processing</b>"
            class="hide-hor-scroll p-1 menu-bg-blue-transparent"
            no-body
          >
            <b-form-group class="px-3 py-2">
              <label>Database Name *</label>
              <b-form-input
                name="databaseName"
                v-model="databaseName"
                autocomplete="off"
              />
              <br />
              <span> Note: Database name is case sensitive. </span>
            </b-form-group>

            <b-container class="p-2" v-if="submitSuccess.length">
              <b-col class="text-center">
                <span>
                  <ul class="list-group">
                    <div
                      class="alert alert-success"
                      v-for="msg in submitSuccess"
                      :key="msg"
                    >
                      <li class="list-group-item">{{ msg }}</li>
                    </div>
                  </ul>
                </span>
              </b-col>
            </b-container>
            <b-row class="p-2" v-if="submitErrors.length > 0">
              <b-col class="text-center">
                <span>
                  <div v-for="(msg, index) in submitErrors">
                    <div class="alert">
                      <span class="alert alert-danger">{{ msg }}</span>
                      <fa :icon="['fas', 'window-close']" @click="removeMsg(index)" class="cursor-pointer"/>
                    </div>
                  </div>
                </span>
              </b-col>
            </b-row>
            <b-row class="p-3">
              <b-col class="text-center">
                <b-button
                  variant="primary"
                  class="btn-md m-2"
                  type="submit"
                  @click="runSubaruScript()"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <!-- SUBARU ANSI Card -->
          <b-card
            v-if="customer == 'Subaru' && processingType == 'ANSI'"
            header-html="<b> SUBARU Processing (ANSI/DRT)</b>"
            class="hide-hor-scroll menu-bg-blue-transparent"
            no-body
          >
            <b-form-group class="px-3 py-2">
              <label>Database Name *</label>
              <b-form-input
                name="databaseName"
                v-model="databaseName"
                autocomplete="off"
              />
              <br />
              <span> Note: Database name is case sensitive. </span>
            </b-form-group>
            <b-row class="px-3 py-2" style="width: 100%;" no-gutters v-if="processing_type != 'Biased'">
              <b-col>
                <b-form-group class="pr-3">
                  <label>Part Number*</label>
                  <b-form-input
                    name="partNumber"
                    v-model="partNumber"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <label>Segment Count*</label>
                  <b-form-input
                    name="subaruCount"
                    v-model="subaruCount"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group class="px-3 py-2" v-else>
              <label>Segment Count*</label>
              <b-form-input
                name="subaruCount"
                v-model="subaruCount"
                autocomplete="off"
              />
            </b-form-group>
            <b-container class="p-2" v-if="submitSuccess.length">
              <b-col class="text-center">
                <span>
                  <ul class="list-group">
                    <div
                      class="alert alert-success"
                      v-for="msg in submitSuccess"
                      :key="msg"
                    >
                      <li class="list-group-item">{{ msg }}</li>
                    </div>
                  </ul>
                </span>
              </b-col>
            </b-container>
            <b-row class="p-2" v-if="submitErrors.length > 0">
              <b-col class="text-center">
                <span>
                  <div v-for="(msg, index) in submitErrors">
                    <div class="alert">
                      <span class="alert alert-danger">{{ msg }}</span>
                      <fa :icon="['fas', 'window-close']" @click="removeMsg(index)" class="cursor-pointer"/>
                    </div>
                  </div>
                </span>
              </b-col>
            </b-row>
            <b-row class="p-3">
              <b-col class="text-center">
                <b-button
                  variant="primary"
                  class="btn-md m-2"
                  type="submit"
                  @click="runSubaruScript()"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <!-- RIVIAN ANSI Card -->
          <b-card
            v-if="customer == 'Rivian' && processingType == 'ANSI'"
            header-html="<b> RIVIAN Processing (ANSI/DRT)</b>"
            class="hide-hor-scroll menu-bg-blue-transparent"
            no-body
          >
            <b-form-group class="px-3 py-2">
              <label>Database Name *</label>
              <b-form-input
                name="databaseName"
                v-model="databaseName"
                autocomplete="off"
                disabled
              />
              <br />
              <span> Note: Database name is case sensitive. </span>
            </b-form-group>
            <b-row class="px-3 py-2" style="width: 100%;" no-gutters>
              <b-col>
                <b-form-group class="pr-3">
                  <label>Part Number *</label>
                  <b-form-input
                    name="partNumber"
                    v-model="partNumber"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-container class="p-2" v-if="submitSuccess.length">
              <b-col class="text-center">
                <span>
                  <ul class="list-group">
                    <div
                      class="alert alert-success"
                      v-for="msg in submitSuccess"
                      :key="msg"
                    >
                      <li class="list-group-item">{{ msg }}</li>
                    </div>
                  </ul>
                </span>
              </b-col>
            </b-container>
            <b-row class="p-2" v-if="submitErrors.length > 0">
              <b-col class="text-center">
                <span>
                  <div v-for="(msg, index) in submitErrors">
                    <div class="alert">
                      <span class="alert alert-danger">{{ msg }}</span>
                      <fa :icon="['fas', 'window-close']" @click="removeMsg(index)" class="cursor-pointer"/>
                    </div>
                  </div>
                </span>
              </b-col>
            </b-row>
            <b-row class="p-3">
              <b-col class="text-center">
                <b-button
                  variant="primary"
                  class="btn-md m-2"
                  type="submit"
                  @click="runRivianScript()"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <!--Nissan Card -->
          <b-card
            v-if="customer == 'Nissan' && processingType == 'ANSI'"
            header-html="<b> NISSAN Processing (ANSI/DRT)</b>"
            class="hide-hor-scroll menu-bg-blue-transparent"
            no-body
          >
            <b-form-group class="px-3 py-2">
              <label>Database Name *</label>
              <b-form-input
                name="databaseName"
                v-model="databaseName"
                autocomplete="off"
              />
              <br />
              <span> Note: Database name is case sensitive. </span>
            </b-form-group>
            <b-row class="px-3 py-2" style="width: 100%;" no-gutters>
              <b-col>
                <b-form-group class="pr-3">
                  <label>Part Number*</label>
                  <b-form-input
                    name="partNumber"
                    v-model="partNumber"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <label>Segment Count*</label>
                  <b-form-input
                    name="nissanCount"
                    v-model="nissanCount"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-container class="p-2" v-if="submitSuccess.length">
              <b-col class="text-center">
                <span>
                  <ul class="list-group">
                    <div
                      class="alert alert-success"
                      v-for="msg in submitSuccess"
                      :key="msg"
                    >
                      <li class="list-group-item">{{ msg }}</li>
                    </div>
                  </ul>
                </span>
              </b-col>
            </b-container>
            <b-row class="p-2" v-if="submitErrors.length > 0">
              <b-col class="text-center">
                <span>
                  <div v-for="(msg, index) in submitErrors">
                    <div class="alert">
                      <span class="alert alert-danger">{{ msg }}</span>
                      <fa :icon="['fas', 'window-close']" @click="removeMsg(index)" class="cursor-pointer"/>
                    </div>
                  </div>
                </span>
              </b-col>
            </b-row>
            <b-row class="p-3">
              <b-col class="text-center">
                <b-button
                  variant="primary"
                  class="btn-md m-2"
                  type="submit"
                  @click="runNissanScript()"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <b-card
            v-if="customer == 'Nissan' && processingType == 'FA'"
            header-html="<b> NISSAN FA Patch Processing</b>"
            class="hide-hor-scroll menu-bg-blue-transparent"
            no-body
          >
            <b-form-group class="px-3 py-2">
              <label>DRT Database Name *</label>
              <b-form-input
                name="databaseName"
                v-model="databaseName"
                autocomplete="off"
              />
              <br />
              <span> Note: Database name is case sensitive. </span>
            </b-form-group>
            <b-form-group class="px-3 py-2">
              <label>FA Database Name *</label>
              <b-form-input name="faDb" v-model="faDb" autocomplete="off" />
              <br />
              <span> Note: Database name is case sensitive. </span>
            </b-form-group>
            <b-form-group class="px-3 py-2">
              <label>Patch Name</label>
              <b-form-input
                name="patchName"
                v-model="patchName"
                autocomplete="off"
              />
            </b-form-group>
            <b-container class="p-2" v-if="submitSuccess.length">
              <b-col class="text-center">
                <span>
                  <ul class="list-group">
                    <div
                      class="alert alert-success"
                      v-for="msg in submitSuccess"
                      :key="msg"
                    >
                      <li class="list-group-item">{{ msg }}</li>
                    </div>
                  </ul>
                </span>
              </b-col>
            </b-container>
            <b-row class="p-2" v-if="submitErrors.length > 0">
              <b-col class="text-center">
                <span>
                  <div v-for="(msg, index) in submitErrors">
                    <div class="alert">
                      <span class="alert alert-danger">{{ msg }}</span>
                      <fa :icon="['fas', 'window-close']" @click="removeMsg(index)" class="cursor-pointer"/>
                    </div>
                  </div>
                </span>
              </b-col>
            </b-row>
            <b-row class="p-3">
              <b-col class="text-center">
                <b-button
                  variant="primary"
                  class="btn-md m-2"
                  type="submit"
                  @click="runNissanFAScript()"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab title="Check Status" v-if="processingType != 'FA'">
          <b-card
            header-html="<b>Processing</b>"
            class="hide-hor-scroll mt-4 menu-bg-blue-transparent"
            no-body
          >
            <b-form-group class="px-3 py-2">
              <label>Database Name *</label>
              <b-form-input
                name="databaseName"
                v-model="databaseName"
                autocomplete="off"
              />
              <br />
              <span> Note: Database name is case sensitive. </span>
            </b-form-group>

            <b-container class="p-2" v-if="submitSuccess.length">
              <b-col class="text-center">
                <span>
                  <ul class="list-group">
                    <div
                      class="alert alert-success"
                      v-for="msg in submitSuccess"
                      :key="msg"
                    >
                      <li class="list-group-item">{{ msg }}</li>
                    </div>
                  </ul>
                  <div v-if="indexes" class="m-1">
                    <span class="m-1"
                      >Found following indexes created successfully.</span
                    >
                    <div
                      class="menu-bg-blue-transparent"
                      v-for="index in indexes"
                      :key="index.itag"
                    >
                      <span class="m-1 p-1">{{ index.itag }}</span>
                    </div>
                  </div>
                </span>
              </b-col>
            </b-container>
            <b-row class="p-2" v-if="submitErrors.length > 0">
              <b-col class="text-center">
                <span>
                  <div v-for="(msg, index) in submitErrors">
                    <div class="alert">
                      <span class="alert alert-danger">{{ msg }}</span>
                      <fa :icon="['fas', 'window-close']" @click="removeMsg(index)" class="cursor-pointer"/>
                    </div>
                  </div>
                </span>
              </b-col>
            </b-row>
            <b-row class="p-3">
              <b-col class="text-center">
                <b-button
                  variant="primary"
                  class="btn-md m-2"
                  type="submit"
                  @click="checkStatus()"
                >
                  Check Status
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
      </b-tabs>
    </div>
  </b-modal>
</template>

<style>
.sa-modal .menu-bg-blue-transparent,
.sa-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.sa-modal label { color: rgba(6, 60, 109, 0.7); }
.sa-modal .form-control {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
}
.sa-modal .form-control::placeholder { color: rgba(6, 60, 109, 0.35); }
.sa-modal .form-control:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}
.sa-modal .card { border-color: rgba(6, 60, 109, 0.15) !important; }
.sa-modal .card-header {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
}
.sa-modal .nav-pills .nav-link {
  color: rgba(6, 60, 109, 0.65);
  background: transparent;
  border: 1px solid rgba(6, 60, 109, 0.3);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  margin: 0 4px;
  transition: background 0.15s;
}
.sa-modal .nav-pills .nav-link.active {
  background: #063c6d !important;
  color: #fff !important;
  border-color: #063c6d !important;
}
</style>

<script>
import axios from 'axios'
export default {
  name: 'MMP_ScriptAutomation',
  data() {
    return {
      submitSuccess: [],
      submitErrors: [],
      databaseName: null,
      date: null,
      type: null,
      partNumber: null,
      count: null,
      nissanCount: null,
      subaruCount: null,
      processing_type: null,
      procedure_list_gm: [
        {name: 'process_drt_delivery_gm_signs_idx'},
        {name: 'process_drt_delivery_gm_marker_idx'},
        {name: 'process_drt_delivery_gm_lane_idx'},
        {name: 'process_drt_delivery_gm_edges_idx'},
        {name: 'process_drt_delivery_gm_barriers_idx'},
        {name: 'process_drt_delivery_gm_delivered_roads_gix'},
        {name: 'process_drt_delivery_gm_point_idx'},
        {name: 'process_drt_delivery_gm_web_schema'},
        {name: 'process_drt_delivery_gm_crossings_idx'},
        {name: 'process_drt_delivery_gm_stacking_idx'},
        {name: 'process_drt_delivery_gm_transition_point_idx'}
      ],
      drtTableName: null,
      customer: null,
      dblink: null,
      processingType: null,
      faDb: null,
      patchName: null,
      indexes: [],
      dblist: []
    }
  },
  methods: {
    hideMsg() {
      this.submitSuccess = []
      this.submitErrors = []
    },
    removeMsg(index) {
      this.submitErrors.splice(index, 1)
      this.submitSuccess.splice(index, 1)
    },
    checkStatus() {
      this.checkDRTFormErrors();
      let dbname = this.databaseName
      this.processingType =
        this.processingType == 'Nissan' ? null : this.processingType
      let url
      switch ((this.customer, this.processingType)) {
        case ('GM', 'ANSI'):
          url = 'checkScriptStatus_pubdb/'
          break
        case ('GM', 'DRT'):
          url = 'checkScriptStatus/'
          break
        case ('Nissan', null):
          url = 'checkScriptStatus_pubdb/'
          break
        case ('Subaru', 'DRT'):
          url = 'checkScriptStatus_subaru/'
          break
        case ('Subaru', 'ANSI'):
          url = 'checkScriptStatus_pubdb/'
          break
      }
      if (this.submitErrors.length == 0 && sessionStorage.token) {
        var self = this
        axios
          .get(
            process.env.API_LOCATION +
              '/api/script_automation/' +
              url +
              dbname,
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                dbname: dbname,
                dbserver: this.dblink,
                customer: this.customer
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('script_automation API Call Error: ' + content.errors)
            } else {
              if (content.length > 0) {
                this.hideMsg()
                this.submitSuccess.push('Processing completed successfully .')
                if (this.customer == 'GM' && this.processingType == 'DRT') {
                  this.indexes = content
                }
                return
              } else {
                this.hideMsg()
                this.submitErrors.push('Database is unproccessed.')
                return
              }
            }
          })
          .catch(function (error) {
            self.submitErrors.push('Database is unproccessed.')
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    refreshModal() {
      this.databaseName = ''
      this.hideMsg()
      this.date = null
      this.type = null
      this.partNumber = null
      this.count = null
    },
    checkAnsiFormErrors() {
      this.submitErrors = []
      if (this.dblink == null) {
        this.submitErrors.push('Please select a server.')
      }
      if ((this.customer == 'GM' || this.customer == 'Subaru') && this.processing_type == null) {
        this.submitErrors.push('Please select a processing type.')
      }
      if (this.databaseName == null) {
        this.submitErrors.push('Please enter database name.')
      }
      if (this.customer == 'GM' && this.type == null) {
        this.submitErrors.push('Please select type of delivery.')
      }
      if (this.customer == 'GM' && this.date == null) {
        this.submitErrors.push('Please enter date.')
      }
      if (this.processing_type != 'Biased' && this.partNumber == null) {
        this.submitErrors.push('Please enter part number.')
      }
      if (this.customer == 'GM' && (this.count == null || this.count <= 0)) {
        this.submitErrors.push('Please enter a valid segment count.')
      }
      if (this.customer == 'Nissan' && (this.nissanCount == null || this.nissanCount <= 0)) {
        this.submitErrors.push('Please enter a valid segment count.')
      }
      if (this.customer == 'Subaru' && (this.subaruCount == null || this.subaruCount <= 0)) {
        this.submitErrors.push('Please enter a valid segment count.')
      }
    },
    checkFaFormErrors() {
      this.submitErrors = []
      if (this.dblink == null) {
        this.submitErrors.push('Please select a server.')
      }
      if (this.databaseName == null) {
        this.submitErrors.push('Please enter DRT database name.')
      }
      if (this.faDb == null) {
        this.submitErrors.push('Please enter FA database name.')
      }
      if (this.patchName == null) {
        this.submitErrors.push('Please enter patch name.')
      }
    },
    checkDRTFormErrors() {
      this.submitErrors = []
      if (this.dblink == null) {
        this.submitErrors.push('Please select a server.')
      }
      if (this.databaseName == null) {
        this.submitErrors.push('Please enter DRT database name.')
      }
    },
    runGMAnsiScript() {
      this.checkAnsiFormErrors()
      if (this.submitErrors == 0) {
        let dbname = this.databaseName
        if (sessionStorage.token) {
          var self = this
          axios
            .get(
              process.env.API_LOCATION +
                '/api/script_automation/checkDbConnection/',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  dbname: dbname,
                  dbserver: this.dblink
                }
              }
            )
            .then(response => {
              const content = response.data
              if (content.errors) {
                console.log(' API Call Error: ' + content.errors)
              } else {
                if (content.length > 0) {
                  if (content[0].dblink_connect == 'OK') {
                    this.hideMsg()
                    this.submitSuccess.push(
                      'Connection is successful . Proccessing scripts.'
                    )
                    if (this.type == 'CSAV3') {
                      this.drtTableName = 'csav3'
                    } else {
                      this.drtTableName = 'csav3_plus'
                    }
                    axios
                      .get(
                        process.env.API_LOCATION +
                          '/api/script_automation/process_ansi_delivery_gm',
                        {
                          headers: {
                            'x-auth-token': sessionStorage.token
                          },
                          params: {
                            dbname: dbname,
                            date: this.date,
                            type: this.type,
                            partNumber: this.partNumber,
                            count: this.count,
                            drtTableName: this.drtTableName,
                            dbserver: this.dblink,
                            processing_type: this.processing_type
                          }
                        }
                      )
                      .then(response => {
                        const content = response.data
                        if (content.errors) {
                          console.log(' API Call Error: ' + content.errors)
                        }
                      })
                      .catch(function (error) {
                        console.log(error)
                      })
                  }
                }
              }
            })
        }
      }
    },
    runNissanScript() {
      this.checkAnsiFormErrors()
      let dbname = this.databaseName
      if (this.submitErrors.length == 0 && sessionStorage.token) {
        var self = this
        axios
          .get(
            process.env.API_LOCATION +
              '/api/script_automation/checkDbConnection_DRT_Nissan/' +
              dbname,
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                dbname: dbname,
                dbserver: this.dblink
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log(' API Call Error: ' + content.errors)
            } else {
              if (content.length > 0) {
                if (content[0].dblink_connect == 'OK') {
                  this.hideMsg()
                  this.submitSuccess.push(
                    'Connection is successful . Proccessing scripts.'
                  )
                  axios
                    .get(
                      process.env.API_LOCATION +
                        '/api/script_automation/nissan_processing',
                      {
                        headers: {
                          'x-auth-token': sessionStorage.token
                        },
                        params: {
                          dbname: dbname,
                          count: this.nissanCount,
                          dbserver: this.dblink,
                          partNumber: this.partNumber
                        }
                      }
                    )
                    .then(response => {
                      const content = response.data
                      if (content.errors) {
                        console.log(' API Call Error: ' + content.errors)
                      }
                    })
                    .catch(function (error) {
                      console.log(error)
                    })
                }
              }
            }
          })
          .catch(function (error) {
            self.submitErrors.push('Database does not exists.')
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    runSubaruScript() {
      this.checkAnsiFormErrors();
      if (this.submitErrors.length == 0 && sessionStorage.token) {
        var self = this
        axios.get(
          process.env.API_LOCATION +
            '/api/script_automation/checkDbConnection/',
          {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              dbname: this.databaseName,
              dbserver: this.dblink
            }
          }
        )
        .then(response => {
          const content = response.data
          if (content.errors) {
            console.log('checkDbConnection API Call Error: ' + content.errors)
          } else {
            if (content.length > 0) {
              if (content[0].dblink_connect == 'OK') {
                this.hideMsg()
                this.submitSuccess.push(
                  'Connection is successful. Proccessing scripts.'
                )
                axios
                  .get(
                    process.env.API_LOCATION +
                      '/api/script_automation/subaru_processing',
                    {
                      headers: {
                        'x-auth-token': sessionStorage.token
                      },
                      params: {
                        dbname: this.databaseName,
                        count: this.subaruCount,
                        ansiType: this.processing_type,
                        server: this.dblink,
                        partNumber: this.partNumber,
                        processingType: this.processingType
                      }
                    }
                  )
                  .then(response => {
                    const content = response.data
                    if (content.errors) {
                      console.log('subaru_processing API Call Error: ' + content.errors)
                    }
                  })
                  .catch(function (error) {
                    console.log(error)
                  })
              }
            }
          }
        })
      }
    },
    checkRivianFormErrors() {
      this.submitErrors = []
      if (this.processingType == null) {
        this.submitErrors.push('Please select a processing type.')
      }
      if (this.processingType == 'ANSI' && this.processing_type == null) {
        this.submitErrors.push('Please select an ansi processing type.')
      }
      if (this.databaseName == null) {
        this.submitErrors.push('Please enter database name.')
      }
      if (this.partNumber == null) {
        this.submitErrors.push('Please enter part number.')
      }
    },
    runRivianScript() {
      this.checkRivianFormErrors();
      if (this.submitErrors.length == 0 && sessionStorage.token) {
        var self = this
        axios.get(
          process.env.API_LOCATION +
            '/api/script_automation/checkRivianDbConnection/',
          {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              dbname: this.databaseName,
              dbserver: this.dblink
            }
          }
        )
        .then(response => {
          const content = response.data
          if (content.errors) {
            console.log('checkRivianDbConnection API Call Error: ' + content.errors)
          } else {
            if (content.length > 0) {
              if (content[0].dblink_connect == 'OK') {
                this.hideMsg()
                this.submitSuccess.push(
                  'Connection is successful. Proccessing scripts.'
                )
                axios
                  .get(
                    process.env.API_LOCATION +
                      '/api/script_automation/rivian_ansi_processing',
                    {
                      headers: {
                        'x-auth-token': sessionStorage.token
                      },
                      params: {
                        dbname: this.databaseName,
                        ansiType: this.processing_type, // Biased, regular...
                        server: this.dblink,
                        partNumber: this.partNumber,
                        processingType: this.processingType // ANSI OR DRT
                      }
                    }
                  )
                  .then(response => {
                    const content = response.data
                    if (content.errors) {
                      console.log('rivian_ansi_processing API Call Error: ' + content.errors)
                    }
                  })
                  .catch(function (error) {
                    console.log(error)
                  })
              }
            }
          }
        })
      }
    },
    runGMDrtScript() {
      this.checkDRTFormErrors();
      let dbname = this.databaseName
      if (this.submitErrors.length == 0 && sessionStorage.token) {
        var self = this
        axios
          .get(
            process.env.API_LOCATION +
              '/api/script_automation/checkDbConnection',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                dbname: dbname,
                dbserver: this.dblink
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log(' API Call Error: ' + content.errors)
            } else {
              if (content.length > 0) {
                if (content[0].dblink_connect == 'OK') {
                  this.hideMsg()
                  this.submitSuccess.push(
                    'Connection is successful . Proccessing scripts.'
                  )
                  this.procedure_list_gm.forEach(item => {
                    axios
                      .get(
                        process.env.API_LOCATION +
                          '/api/script_automation/gm_processing',
                        {
                          headers: {
                            'x-auth-token': sessionStorage.token
                          },
                          params: {
                            dbname: dbname,
                            procedureName: item.name,
                            dbserver: this.dblink
                          }
                        }
                      )
                      .then(response => {
                        const content = response.data
                        if (content.errors) {
                          console.log('gm_processing API Call Error: ' + content.errors)
                        }
                      })
                      .catch(function (error) {
                        console.log(error)
                      })
                  })
                }
              }
            }
          })
          .catch(function (error) {
            self.submitErrors = 'Database does not exists.'
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    runNissanFAScript() {
      this.checkFaFormErrors()
      let dbname = this.databaseName
      if (this.submitErrors.length == 0 && sessionStorage.token) {
        var self = this
        axios
          .get(
            process.env.API_LOCATION +
              '/api/script_automation/checkDbConnection_DRT_Nissan/' +
              dbname,
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                dbname: dbname,
                dbserver: this.dblink
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log(' API Call Error: ' + content.errors)
            } else {
              if (content.length > 0) {
                if (content[0].dblink_connect == 'OK') {
                  this.hideMsg()
                  this.submitSuccess.push(
                    'Connection is successful . Proccessing scripts.'
                  )
                  axios
                    .get(
                      process.env.API_LOCATION +
                        '/api/script_automation/nissan_FA_processing',
                      {
                        headers: {
                          'x-auth-token': sessionStorage.token
                        },
                        params: {
                          dbname: dbname,
                          faDb: this.faDb,
                          patchname: this.patchName,
                          dbserver: this.dblink
                        }
                      }
                    )
                    .then(response => {
                      const content = response.data
                      if (content.errors) {
                        console.log(' API Call Error: ' + content.errors)
                      }
                    })
                    .catch(function (error) {
                      console.log(error)
                    })
                }
              }
            }
          })
          .catch(function (error) {
            self.submitErrors.push('Database does not exists.')
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getDbConnections() {
      if (this.submitErrors.length == 0 && sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
              '/api/script_automation/getDatabaseConnections',
            {
              method: 'GET',
              headers: {
                'x-auth-token': sessionStorage.token
              }
            }
          )
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.dblist = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  },
  mounted() {
    this.getDbConnections()
  },
  watch: {
    customer: function (newValue) {
      if (newValue == 'Rivian') {
        this.databaseName = 'rivian_udbx_latest'
      } else {
        this.databaseName = null;
      }
    }
  }
}
</script>
